// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"228":"96636ad7","506":"2978cfb2"}[chunkId] + ".css";
};